export default "__VITE_ASSET__d51bfb67__"